/*eslint-disable*/
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../../Components/Modal/modal';
import './mapEmployee.scss';
import { CircularProgress, TextField, Autocomplete } from '@mui/material';
import CommonTextField from '../../../Components/TextField/textField';
import SearchDropdown from '../../../Components/Dropdown/dropdown';
import ProfilePicPlaceHolder from '../../../Assets/images/png/profil-pic-placeholder-large.png';
import { STAFF_AUGMENTATION } from '../../../Constants/strings';
import { makeStyles } from '@mui/styles';
import useMapEmployee from './useMapEmployee';
import UseAxios from '../../../Api/http/http';
import { mapResource } from '../../../Api/request/staffAugmentation';
import { updateRequestResourceData } from '../../../Api/request//resourceRequest';
import { AuthContext } from '../../../Contexts/AuthContext';

const MapEmployee = ({
  modalOpen,
  handleClose,
  statusOptions,
  staffId,
  getResourceRequirementData,
  editEmployeeData
}) => {
  const {
    loadingEmployeeList,
    employeeDetails,
    employeeOptions,
    handleEmployeeDetails,
    handleEmployeeNameChange,
    handleEmployeeStatusDeatils,
    handleResetEmployeeDetails,
    checkMapBtnDisabled,
    handleResponse,
    handleOthersChange,
    setEmployeeDetails,
  } = useMapEmployee();
  const { userProfile } = useContext(AuthContext);
  const useStyles = makeStyles({
    noOptions: {
      display: 'none',
    },
  });
  const styles = useStyles();
  const [initialEditValues, setInitialEditValues] = useState(null);

  const handleCloseModal = () => {
    handleResetEmployeeDetails();
    handleClose();
  };

  const handleSubmit = async () => {
    let payload = {
      staffingId: staffId,
      statusId: employeeDetails.status?.id,
      lastUpdatedBy: userProfile.user_name,
    };
   
    if (editEmployeeData) {
      payload.resourceId = editEmployeeData.id;
      
     
      if (employeeDetails.others && employeeDetails.others.trim() !== '') {
        payload.others = employeeDetails.others;
        payload.employeeId = null;
      } else if (editEmployeeData.employeeId !== employeeDetails.employeeId) {
    
        payload.employeeId = employeeDetails.employeeId;
        payload.others = null;
      } else {
        payload.others = null;
      }
    } else {
      if (employeeDetails.employeeId) {
        payload.employeeId = [employeeDetails.employeeId];
      }
      
      if (employeeDetails.others && employeeDetails.others.trim() !== '') {
        payload.others = employeeDetails.others;
      }
    }
    
    try {
      let response;
      if (editEmployeeData) {
        response = await UseAxios(updateRequestResourceData(payload));
        if (response.status === 200) {
          getResourceRequirementData();
        }
      } else {
        response = await UseAxios(mapResource(payload));
        if (response.status === 201) {
          getResourceRequirementData();
        }
      }
      handleResponse(response);
    } catch (error) {
      console.log('Error: ', error);
     
      if (error.response) {
        handleResponse(error.response);
      }
    } finally {
      handleCloseModal();
    }
  };

  
  useEffect(() => {
    if (editEmployeeData && modalOpen) {
      const initial = {
        employeeName: editEmployeeData.others ? {} : { fullName: editEmployeeData.employeeName },
        employeeId: editEmployeeData.others ? '' : editEmployeeData.employeeId,
        employeeEmail: editEmployeeData.others ? '' : editEmployeeData.emailId,
        status:
          statusOptions.find(
            (s) => s.id === editEmployeeData.statusId || s.name === editEmployeeData.status
          ) || null,
        others: editEmployeeData.others || '',
      };
      setEmployeeDetails(initial);
      setInitialEditValues(initial);
    } else if (!modalOpen) {
      setEmployeeDetails({
        employeeName: {},
        employeeId: '',
        employeeEmail: '',
        status: null,
        others: '',
      });
      setInitialEditValues(null);
    }
  }, [editEmployeeData, modalOpen, setEmployeeDetails, statusOptions]);

  
  const isEditUnchanged = () => {
    if (!editEmployeeData || !initialEditValues) return false;
    return (
      (employeeDetails.employeeName?.fullName || '') === (initialEditValues.employeeName?.fullName || '') &&
      (employeeDetails.employeeId || '') === (initialEditValues.employeeId || '') &&
      (employeeDetails.employeeEmail || '') === (initialEditValues.employeeEmail || '') &&
      (employeeDetails.status?.id || employeeDetails.status?.name || '') === (initialEditValues.status?.id || initialEditValues.status?.name || '') &&
      (employeeDetails.others || '') === (initialEditValues.others || '')
    );
  };

  return (
    <div>
      <FormDialog
        title={editEmployeeData ? STAFF_AUGMENTATION.REQUEST_RESOURCING.EDIT_MAP_EMPLOYEE : STAFF_AUGMENTATION.REQUEST_RESOURCING.MAP_EMPLOYEE}
        open={modalOpen}
        handleClose={handleCloseModal}
        button1Action={handleCloseModal}
        dialogBodycontent={
          <div className="map-employee-form">
            <div>
              <label htmlFor="map-employee-name" className="map-emp-name-label">
                {STAFF_AUGMENTATION.MAP_EMPLOYEE_FIELD.EMPLOYEE_NAME}
              </label>
              <Autocomplete
                id="map-employee-name"
                classes={{ noOptions: styles.noOptions }}
                className={employeeDetails?.others ? 'disabled-autocomplete' : ''}
                value={employeeDetails?.employeeName}
                inputValue={employeeDetails?.employeeName?.fullName}
                onInputChange={(_event_, newValue) => {
                  handleEmployeeNameChange(newValue);
                }}
                onChange={(_event_, newValue) => {
                  handleEmployeeDetails(newValue);
                }}
                loadingText={
                  <div className="map-emp-loading">
                    <CircularProgress size={24} />
                  </div>
                }
                loading={loadingEmployeeList}
                options={employeeOptions}
                isOptionEqualToValue={(option, value) =>
                  option.fullName === value.fullName
                }
                renderOption={(props, option) => (
                  <li {...props}>
                    <img
                      src={option.photoSignedUrl || ProfilePicPlaceHolder}
                      alt="Profile"
                      className="profile-image"
                    />
                    {`${option.fullName} . ${option.employeeId}`}
                  </li>
                )}
                getOptionLabel={(option) => option.fullName || ''}
                disabled={employeeDetails?.others}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={
                      STAFF_AUGMENTATION.MAP_EMP_FIELD_PLACEHOLDER.EMPLOYEE_NAME
                    }
                    sx={{
                      '& .MuiInputBase-root': {
                        height: '34px',
                        padding: '0px 14px',
                      },
                      '& .MuiInputBase-input': {
                        fontSize: 'small',
                        '&::placeholder': {
                          color: 'grey',
                          fontSize: 'small',
                        },
                      },
                    }}
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    required
                    disabled={employeeDetails?.others}
                  />
                )}
              />
            </div>

            <CommonTextField
              label={STAFF_AUGMENTATION.MAP_EMPLOYEE_FIELD.EMPLOYEE_ID}
              value={employeeDetails?.employeeId}
              variant="outlined"
              textCss="map-emp-text-field"
              autoFocus={false}
              size="small"
              id="requirement_emp_id"
              disabled
            />

            <CommonTextField
              label={STAFF_AUGMENTATION.MAP_EMPLOYEE_FIELD.EMPLOYEE_EMAIL}
              value={employeeDetails?.employeeEmail}
              variant="outlined"
              textCss="map-emp-text-field"
              autoFocus={false}
              size="small"
              id="requirement_emp_email"
              disabled
            />

            <CommonTextField
              label={STAFF_AUGMENTATION.MAP_EMPLOYEE_FIELD.OTHERS}
              value={employeeDetails?.others}
              variant="outlined"
              textCss="map-emp-text-field"
              autoFocus={false}
              size="small"
              id="requirement_others"
              disabled={!!employeeDetails?.employeeId}
              onChange={(e) => handleOthersChange(e.target.value)}
              placeholder="Enter consultant name"
              maxLength={255}
              maxLengthCount={255}
            />
            <SearchDropdown
              label={STAFF_AUGMENTATION.MAP_EMPLOYEE_FIELD.STATUS}
              options={statusOptions}
              value={employeeDetails?.status}
              searchBox={false}
              onChange={(event) => handleEmployeeStatusDeatils(event)}
              placeholder={STAFF_AUGMENTATION.MAP_EMP_FIELD_PLACEHOLDER.STATUS}
              id="requirement_emp_status"
            />
          </div>
        }
        button1="Cancel"
        button2={editEmployeeData ? "Update" : "Save"}
        button2Action={handleSubmit}
        cancelButtonId="cancel-map-resoure"
        submitButtonId="submit-map-resoure"
        button2Disabled={editEmployeeData ? (checkMapBtnDisabled() || isEditUnchanged()) : checkMapBtnDisabled()}
      />
    </div>
  );
};

MapEmployee.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  statusOptions: PropTypes.array.isRequired,
  staffId: PropTypes.number.isRequired,
  setRows: PropTypes.func,
  editEmployeeData: PropTypes.object, 
};

export default MapEmployee;
